/**
 * Hansteinmedia: Produkte mit Tag „einmalig“ (z. B. Endreinigung) höchstens 1× im Warenkorb.
 *
 * - <einmalig-korrektur data-line="n"> wird von snippets/cart-products.liquid ausgegeben, wenn eine solche Zeile
 *   mehr als 1 Stück hat (z. B. Doppelklick, Schnellkauf auf einer Produktkarte): Menge per /cart/change.js auf 1
 *   setzen und neu laden.
 * - Produktseite (product-form-component[data-einmalig]): nach dem Hinzufügen den Knopf sperren und
 *   „Bereits im Warenkorb“ anzeigen.
 */
class EinmaligKorrektur extends HTMLElement {
  connectedCallback() {
    if (this.dataset.done) return;
    this.dataset.done = '1';
    const line = Number(this.dataset.line);
    const url = (window.Theme?.routes?.cart_change_url || '/cart/change') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: 1 }),
    })
      .then((response) => (response.ok ? window.location.reload() : null))
      .catch(() => {});
  }
}
if (!customElements.get('einmalig-korrektur')) customElements.define('einmalig-korrektur', EinmaligKorrektur);

document.addEventListener('cart:update', (event) => {
  if (event.detail?.data?.didError) return;
  for (const form of document.querySelectorAll('product-form-component[data-einmalig]')) {
    const productId = String(event.detail?.data?.productId || '');
    if (productId && productId !== form.dataset.productId) continue;
    const button = form.querySelector('button[name="add"]');
    if (!button) continue;
    // nach der „Hinzugefügt“-Animation sperren
    setTimeout(() => {
      button.disabled = true;
      const label = button.querySelector('.add-to-cart-text');
      if (label) label.textContent = form.dataset.einmalig;
    }, 1500);
  }
});
